exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-d593135e]{background:#000;opacity:.7}.overlay-enter[data-v-d593135e],.overlay-leave-to[data-v-d593135e]{opacity:0}.overlay-enter-active[data-v-d593135e],.overlay-leave-active[data-v-d593135e]{transition:all .3s}", ""]);

// exports
